import lodash from 'lodash'
import { getFloorIndex } from '@/api/buildings/request'
import { decimalFilter } from './regex'

export const SORT_DIRECTION = {
  ASC: 'asc',
  DESC: 'desc',
}

const NATURAL_CODE_NUMBER_LENGTH = 15
const PERMIT_CODE_PATTERN = /^([A-Z]+\d*|\d+)-(\d+)(?:-(\d+))?$/i

export function sortBids (bids = [], sortedBy = 'name') {
  return lodash.orderBy(bids, sortedBy)
}

export function numberIterator (value, order) {
  const lastOne = order === SORT_DIRECTION.ASC ? Number.MAX_SAFE_INTEGER : Number.MIN_SAFE_INTEGER
  if (typeof value === 'number') return value
  if (typeof value === 'string') return parseFloat(value.replace(decimalFilter, ''))
  console.debug('Please be aware that the value is not a valid number', value, typeof value)
  return lastOne
}

export const sortFloors = (floor, buildingCode) => {
  const sortedFloorArray = lodash.sortBy(floor, item => {
    return getFloorIndex(buildingCode, item)
  })
  return sortedFloorArray
}

export const orderItemByGroup = (item, orderAttrs) => {
  for (const [index, value] of orderAttrs.entries()) {
    if (item[value]) {
      return index
    }
  }
  return orderAttrs.length
}

function padCodeNumber (value) {
  return String(value || '').padStart(NATURAL_CODE_NUMBER_LENGTH, '0')
}

function naturalCodeSortKey (code) {
  return String(code || '').toUpperCase().replace(/\d+/g, match => match.padStart(NATURAL_CODE_NUMBER_LENGTH, '0'))
}

export function permitCodeSortKey (code) {
  const codeText = String(code || '').toUpperCase()
  const match = codeText.match(PERMIT_CODE_PATTERN)
  if (!match) return naturalCodeSortKey(codeText)

  const [, prefix, permitNumber, suffix] = match
  const suffixKey = suffix ? `1${padCodeNumber(suffix)}` : `0${padCodeNumber(0)}`
  return [
    naturalCodeSortKey(prefix),
    padCodeNumber(permitNumber),
    suffixKey,
    codeText,
  ].join(':')
}

export function durationPermitCodeSortKey (startDate, code) {
  const timestamp = new Date(startDate).getTime()
  const durationSortKey = Number.isNaN(timestamp) ? Number.MAX_SAFE_INTEGER : timestamp
  return `${String(durationSortKey).padStart(NATURAL_CODE_NUMBER_LENGTH, '0')}:${permitCodeSortKey(code)}`
}

export function orderByPermitCode (items = [], orders = ['asc']) {
  return lodash.orderBy(items, [item => permitCodeSortKey(item && item.code)], orders)
}
